"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var TablePagination_1 = __importDefault(require("../../TablePagination"));
var useLabelDisplayedRows_1 = __importDefault(require("./hooks/useLabelDisplayedRows"));
var Pagination = function (props) {
    var _a = props.count, count = _a === void 0 ? 0 : _a, _b = props.onChangePage, onChangePage = _b === void 0 ? function () { } : _b, _c = props.page, page = _c === void 0 ? 0 : _c, _d = props.rowsPerPage, rowsPerPage = _d === void 0 ? 0 : _d, classes = props.classes, translate = props.translate;
    var labelDisplayedRows = (0, useLabelDisplayedRows_1.default)(translate);
    return (react_1.default.createElement(TablePagination_1.default, { count: count, onChangePage: onChangePage, page: page, rowsPerPage: rowsPerPage, classes: classes, labelRowsPerPage: "", rowsPerPageOptions: [], labelDisplayedRows: labelDisplayedRows, component: "div" }));
};
exports.default = Pagination;
